export const FEATURE_TOGGLE_AD_SERVER = 'useAdServer'
export const FEATURE_TOGGLE_BONUS_LP_NEW_DESIGN = 'useErxBonusLpNewDesign'
export const FEATURE_TOGGLE_USE_COPAYMENT_EXEMPTION = 'useCopaymentExemption'
export const FEATURE_TOGGLE_FRIENDLY_CAPTCHA = 'friendlyCaptcha'
export const FEATURE_TOGGLE_ONE_TIME_PASSWORD = 'oneTimePasswordLoginEnabled'
export const FEATURE_TOGGLE_PAPERLESS_PACKAGES = 'paperlessPackages'
export const FEATURE_TOGGLE_PICKUP_STATIONS_ACTIVE = 'pickupStationsActive'
export const FEATURE_TOGGLE_REDPOINTS_ACTIVE = 'redpoints.active'
export const FEATURE_TOGGLE_REVIEWS_FROM_OTHER_LANGUAGES =
  'showReviewsFromOtherLanguages'
export const FEATURE_TOGGLE_SAE_CONVERSATIONAL_CHAT = 'saeConversationalChat'
export const FEATURE_TOGGLE_SELLER_CENTRAL = 'useSellerCentral'
export const FEATURE_TOGGLE_SHIPPING_DELAY_NOTIFICATION = 'wstra-6359'
export const FEATURE_TOGGLE_USE_CREDIT_BALANCE_SERVICE_FOR_ELIGIBLE_CREDIT =
  'useCreditBalanceServiceForEligibleCredit'
export const FEATURE_TOGGLE_USE_INTERACTIONS = 'useInteractions'
export const FEATURE_TOGGLE_USE_LEAFLETS = 'useLeaflets'
export const FEATURE_TOGGLE_VOLUME_BASED_PRICES =
  'useMarketplaceVolumeBasedPrices'

/**
 * Please remove the feature toggle when it is removed from all tenants and environments.
 */
export const privateFeatureToggleNameSet = new Set([
  FEATURE_TOGGLE_AD_SERVER,
  FEATURE_TOGGLE_BONUS_LP_NEW_DESIGN,
  FEATURE_TOGGLE_USE_COPAYMENT_EXEMPTION,
  FEATURE_TOGGLE_FRIENDLY_CAPTCHA,
  FEATURE_TOGGLE_ONE_TIME_PASSWORD,
  FEATURE_TOGGLE_PAPERLESS_PACKAGES,
  FEATURE_TOGGLE_PICKUP_STATIONS_ACTIVE,
  FEATURE_TOGGLE_REDPOINTS_ACTIVE,
  FEATURE_TOGGLE_REVIEWS_FROM_OTHER_LANGUAGES,
  FEATURE_TOGGLE_SAE_CONVERSATIONAL_CHAT,
  FEATURE_TOGGLE_SELLER_CENTRAL,
  FEATURE_TOGGLE_SHIPPING_DELAY_NOTIFICATION,
  FEATURE_TOGGLE_USE_CREDIT_BALANCE_SERVICE_FOR_ELIGIBLE_CREDIT,
  FEATURE_TOGGLE_USE_INTERACTIONS,
  FEATURE_TOGGLE_USE_LEAFLETS,
  FEATURE_TOGGLE_VOLUME_BASED_PRICES,
] as const)

export type PrivateFeatureToggles = Partial<
  Record<
    typeof privateFeatureToggleNameSet extends ReadonlySet<infer Item>
      ? Item
      : never,
    boolean
  >
>

export const publicFeatureToggleNameSet = new Set([
  FEATURE_TOGGLE_AD_SERVER,
  FEATURE_TOGGLE_BONUS_LP_NEW_DESIGN,
  FEATURE_TOGGLE_FRIENDLY_CAPTCHA,
  FEATURE_TOGGLE_ONE_TIME_PASSWORD,
  FEATURE_TOGGLE_PICKUP_STATIONS_ACTIVE,
  FEATURE_TOGGLE_REDPOINTS_ACTIVE,
  FEATURE_TOGGLE_SAE_CONVERSATIONAL_CHAT,
  FEATURE_TOGGLE_SELLER_CENTRAL,
  FEATURE_TOGGLE_VOLUME_BASED_PRICES,
] as const)

export type PublicFeatureToggles = Pick<
  PrivateFeatureToggles,
  typeof publicFeatureToggleNameSet extends ReadonlySet<infer Item>
    ? Item
    : never
>
